import { Card } from "react-bootstrap";

export default function StatCard({ title, value, icon, bg, iconBg }) {
  return (
    <Card className="border-0 shadow-sm" style={{ backgroundColor: bg }}>
      <Card.Body className="py-2 px-3">
        <div className="d-flex justify-content-between align-items-center">
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: 10,
              backgroundColor: iconBg,
            }}
            className="d-flex align-items-center justify-content-center"
          >
            {icon}
          </div>

          <div className="text-end">
            <div className="fw-bold fs-5">{value}</div>
            <small className="text-muted">{title}</small>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
